module.exports = __webpack_public_path__ + "86f72acc48513c80c27a7250a26532ee.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/group/Blue2.jpg
// module id = 16
// module chunks = 0